@import "tailwindcss";
@import "uniwind";

@plugin "tailwindcss-animate";

@custom-variant dark (&:where(.dark, .dark *));

@theme {
  --breakpoint-sm: 640px;
  --breakpoint-md: 768px;
  --breakpoint-menu-lg: 872px;
  --breakpoint-lg: 1024px;
  --breakpoint-xl: 1280px;
  --breakpoint-2xl: 1536px;

  --color-bg: rgb(from var(--color-bg) r g b);
  --color-bg-high: rgb(from var(--color-bg-high) r g b);
  --color-fg: rgb(from var(--color-fg) r g b);
  --color-fg-loud: rgb(from var(--color-fg-loud) r g b);
  --color-muted-fg: rgb(from var(--color-muted-fg) r g b);
  --color-lozenge-emerald-bg: rgb(from var(--color-lozenge-emerald-bg) r g b);
  --color-lozenge-emerald-fg: rgb(from var(--color-lozenge-emerald-fg) r g b);
  --color-lozenge-emerald-border: rgb(
    from var(--color-lozenge-emerald-border) r g b
  );
  --color-lozenge-cyan-bg: rgb(from var(--color-lozenge-cyan-bg) r g b);
  --color-lozenge-cyan-fg: rgb(from var(--color-lozenge-cyan-fg) r g b);
  --color-lozenge-cyan-border: rgb(from var(--color-lozenge-cyan-border) r g b);
  --color-lozenge-blue-bg: rgb(from var(--color-lozenge-blue-bg) r g b);
  --color-lozenge-blue-fg: rgb(from var(--color-lozenge-blue-fg) r g b);
  --color-lozenge-blue-border: rgb(from var(--color-lozenge-blue-border) r g b);
  --color-lozenge-violet-bg: rgb(from var(--color-lozenge-violet-bg) r g b);
  --color-lozenge-violet-fg: rgb(from var(--color-lozenge-violet-fg) r g b);
  --color-lozenge-violet-border: rgb(
    from var(--color-lozenge-violet-border) r g b
  );
  --color-lozenge-fuchsia-bg: rgb(from var(--color-lozenge-fuchsia-bg) r g b);
  --color-lozenge-fuchsia-fg: rgb(from var(--color-lozenge-fuchsia-fg) r g b);
  --color-lozenge-fuchsia-border: rgb(
    from var(--color-lozenge-fuchsia-border) r g b
  );
  --color-lozenge-rose-bg: rgb(from var(--color-lozenge-rose-bg) r g b);
  --color-lozenge-rose-fg: rgb(from var(--color-lozenge-rose-fg) r g b);
  --color-lozenge-rose-border: rgb(from var(--color-lozenge-rose-border) r g b);
  --color-lozenge-orange-bg: rgb(from var(--color-lozenge-orange-bg) r g b);
  --color-lozenge-orange-fg: rgb(from var(--color-lozenge-orange-fg) r g b);
  --color-lozenge-orange-border: rgb(
    from var(--color-lozenge-orange-border) r g b
  );
  --color-lozenge-amber-bg: rgb(from var(--color-lozenge-amber-bg) r g b);
  --color-lozenge-amber-fg: rgb(from var(--color-lozenge-amber-fg) r g b);
  --color-lozenge-amber-border: rgb(
    from var(--color-lozenge-amber-border) r g b
  );

  --color-cloud: rgb(from var(--color-cloud) r g b);
  --color-red: rgb(from var(--color-red) r g b);
  --color-orange: rgb(from var(--color-orange) r g b);
  --color-amber: rgb(from var(--color-amber) r g b);
  --color-yellow: rgb(from var(--color-yellow) r g b);
  --color-lime: rgb(from var(--color-lime) r g b);
  --color-wasabi: rgb(from var(--color-wasabi) r g b);
  --color-green: rgb(from var(--color-green) r g b);
  --color-emerald: rgb(from var(--color-emerald) r g b);
  --color-teal: rgb(from var(--color-teal) r g b);
  --color-cyan: rgb(from var(--color-cyan) r g b);
  --color-cyanold: rgb(from var(--color-cyanold) r g b);
  --color-sky: rgb(from var(--color-sky) r g b);
  --color-blue: rgb(from var(--color-blue) r g b);
  --color-indigo: rgb(from var(--color-indigo) r g b);
  --color-violet: rgb(from var(--color-violet) r g b);
  --color-purple: rgb(from var(--color-purple) r g b);
  --color-fuchsia: rgb(from var(--color-fuchsia) r g b);
  --color-pink: rgb(from var(--color-pink) r g b);
  --color-rose: rgb(from var(--color-rose) r g b);
  --color-brick: rgb(from var(--color-brick) r g b);
  --color-slate: rgb(from var(--color-slate) r g b);
  --color-gray: rgb(from var(--color-gray) r g b);
  --color-zinc: rgb(from var(--color-zinc) r g b);
  --color-neutral: rgb(from var(--color-neutral) r g b);
  --color-stone: rgb(from var(--color-stone) r g b);

  --color-transparent: transparent;
  --color-danger: rgb(from var(--color-danger) r g b);
  --color-warning: rgb(from var(--color-warning) r g b);
  --color-success: rgb(from var(--color-success) r g b);
  --color-currentColor: currentColor;

  --font-cursive:
    ui-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
    "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-sans: NationalPark, MiSans, MiSansL3, LXGWWenKaiGB, PinyinlyComponents;
  --font-mono:
    ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace;

  --spacing-vvh: var(--vvh);
  --spacing-vvw: var(--vvw);
  --spacing-www-col: 988px;

  --pyly-ref-thickness-default: 3px;
  --pyly-ref-offset-default: 2px;
  --pyly-ref-color-default: var(--color-fg-loud);
  --pyly-ref-weight-default: 500;

  --pyly-bold-color-default: var(--color-fg-loud);
  --pyly-bold-weight-default: 600;

  --pyly-mark-color-default: var(--color-yellow);
  --pyly-mark-weight-default: 600;

  --pyly-italic-weight-default: 400;

  --animate-hoscillate: hoscillate 1s ease-in-out infinite;
  --animate-fadein: fadein 0.25s ease-in forwards;
  --animate-shimmerText: shimmerText 2s linear infinite;

  @keyframes hoscillate {
    0%,
    100% {
      transform: translateX(-1px);
      animation-timing-function: ease-in-out;
    }
    50% {
      transform: translateX(1px);
      animation-timing-function: ease-in-out;
    }
  }

  @keyframes fadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes shimmerText {
    0% {
      background-position: 100% 0;
    }
    100% {
      background-position: -100% 0;
    }
  }
}

@keyframes drawHanziStroke {
  from {
    visibility: visible;
    stroke-dashoffset: 1;
  }
  to {
    visibility: visible;
    stroke-dashoffset: 0;
  }
}

@keyframes fadeInHanziReferenceStroke {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes growHanziBrush {
  from {
    stroke-width: 0;
  }
  to {
    stroke-width: var(--hanzi-brush-growth-width);
  }
}

@keyframes dimHanziForeground {
  to {
    opacity: 0;
  }
}

@utility hanzi-animated-stroke {
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
  visibility: hidden;
  animation:
    drawHanziStroke var(--hanzi-stroke-duration) linear
      var(--hanzi-stroke-delay) both,
    growHanziBrush var(--hanzi-brush-growth-duration) ease-out
      var(--hanzi-stroke-delay) both;
}

@utility hanzi-animated-reference-stroke {
  stroke-dasharray: 1;
  stroke-dashoffset: 1;
  visibility: hidden;
  opacity: 0;
  animation:
    drawHanziStroke var(--hanzi-stroke-duration) linear
      var(--hanzi-stroke-delay) both,
    fadeInHanziReferenceStroke 100ms ease-out var(--hanzi-stroke-delay) both;
}

@utility hanzi-animated-foreground {
  animation: dimHanziForeground 2400ms ease-out var(--hanzi-graphic-dim-delay)
    both;
}

@media (prefers-reduced-motion: reduce) {
  .hanzi-animated-stroke {
    animation: none;
    stroke-dashoffset: 0;
    visibility: visible;
  }

  .hanzi-animated-reference-stroke {
    animation: none;
    stroke-dashoffset: 0;
    visibility: visible;
    opacity: 1;
  }

  .hanzi-animated-foreground {
    animation: none;
    opacity: 0;
  }
}

/* Inline derived colors so their inputs resolve in the consuming theme scope,
   rather than inheriting a mix computed on :root. */
@theme inline {
  --color-fg-bg5: color-mix(in oklab, var(--color-fg) 5%, var(--color-bg));
  --color-fg-bg10: color-mix(in oklab, var(--color-fg) 10%, var(--color-bg));
  --color-fg-bg15: color-mix(in oklab, var(--color-fg) 15%, var(--color-bg));
  --color-fg-bg20: color-mix(in oklab, var(--color-fg) 20%, var(--color-bg));
  --color-fg-bg25: color-mix(in oklab, var(--color-fg) 25%, var(--color-bg));
  --color-fg-bg30: color-mix(in oklab, var(--color-fg) 30%, var(--color-bg));
  --color-fg-bg35: color-mix(in oklab, var(--color-fg) 35%, var(--color-bg));
  --color-fg-bg40: color-mix(in oklab, var(--color-fg) 40%, var(--color-bg));
  --color-fg-bg45: color-mix(in oklab, var(--color-fg) 45%, var(--color-bg));
  --color-fg-bg50: color-mix(in oklab, var(--color-fg) 50%, var(--color-bg));
  --color-fg-bg55: color-mix(in oklab, var(--color-fg) 55%, var(--color-bg));
  --color-fg-bg60: color-mix(in oklab, var(--color-fg) 60%, var(--color-bg));
  --color-fg-bg65: color-mix(in oklab, var(--color-fg) 65%, var(--color-bg));
  --color-fg-bg70: color-mix(in oklab, var(--color-fg) 70%, var(--color-bg));
  --color-fg-bg75: color-mix(in oklab, var(--color-fg) 75%, var(--color-bg));
  --color-fg-bg80: color-mix(in oklab, var(--color-fg) 80%, var(--color-bg));
  --color-fg-bg85: color-mix(in oklab, var(--color-fg) 85%, var(--color-bg));
  --color-fg-bg90: color-mix(in oklab, var(--color-fg) 90%, var(--color-bg));
  --color-fg-bg95: color-mix(in oklab, var(--color-fg) 95%, var(--color-bg));
  --color-fg-bg100: color-mix(in oklab, var(--color-fg) 100%, var(--color-bg));
}

@utility pyly-ref-xs {
  text-decoration-thickness: 2px;
  text-underline-offset: 2px;
}

@utility pyly-ref-sm {
  text-decoration-thickness: 2.5px;
  text-underline-offset: 2px;
}

@utility pyly-ref-base {
  text-decoration-thickness: 3px;
  text-underline-offset: 2px;
}

@utility pyly-ref-lg {
  text-decoration-thickness: 3px;
  text-underline-offset: 3px;
}

@utility pyly-ref-xl {
  text-decoration-thickness: 3px;
  text-underline-offset: 3px;
}

@utility pyly-ref-2xl {
  text-decoration-thickness: 4px;
  text-underline-offset: 3px;
}

@utility pyly-token-highlighted {
  @apply outline-rose-500 from-rose-500/50 via-rose-500/50 to-rose-600/50;
}

@utility pyly-button-outline {
  @apply font-sans text-base/snug font-bold uppercase text-fg;
}

@utility pyly-body-title {
  @apply font-sans text-2xl/normal tracking-tight text-fg font-semibold;

  --pyly-ref-thickness: 4px;
  --pyly-ref-offset: 3px;
  --pyly-ref-color: var(--color-fg-loud);
  --pyly-ref-weight: 700;

  --pyly-bold-color: var(--color-fg-loud);
  --pyly-bold-weight: 700;

  --pyly-mark-color: var(--color-yellow);
  --pyly-mark-weight: 800;
}

@utility pyly-body-heading {
  @apply font-sans text-lg/normal tracking-tight text-fg-loud font-semibold;

  --pyly-ref-thickness: 3px;
  --pyly-ref-offset: 3px;
  --pyly-ref-color: var(--color-fg-loud);
  --pyly-ref-weight: 700;

  --pyly-bold-color: var(--color-fg-loud);
  --pyly-bold-weight: 700;

  --pyly-mark-color: var(--color-yellow);
  --pyly-mark-weight: 700;
}

@utility pyly-body-subheading {
  @apply font-sans text-sm/normal text-fg-loud font-semibold uppercase;

  --pyly-ref-thickness: 3px;
  --pyly-ref-offset: 3px;
  --pyly-ref-color: var(--color-fg-loud);
  --pyly-ref-weight: 700;

  --pyly-bold-color: var(--color-fg-loud);
  --pyly-bold-weight: 700;

  --pyly-mark-color: var(--color-yellow);
  --pyly-mark-weight: 700;
}

@utility pyly-body-2xl {
  @apply font-sans text-2xl/normal font-normal text-fg;

  --pyly-ref-thickness: 4px;
  --pyly-ref-offset: 3px;
  --pyly-ref-color: var(--color-fg-loud);
  --pyly-ref-weight: 500;

  --pyly-bold-color: var(--color-fg-loud);
  --pyly-bold-weight: 500;

  --pyly-mark-color: var(--color-yellow);
  --pyly-mark-weight: 500;
}

@utility pyly-body-caption {
  @apply font-sans text-sm/normal font-normal text-muted-fg;

  --pyly-ref-thickness: 2.5px;
  --pyly-ref-offset: 2px;
  --pyly-ref-color: var(--color-fg);
  --pyly-ref-weight: 500;

  --pyly-bold-color: var(--color-fg);
  --pyly-bold-weight: 500;

  --pyly-mark-color: var(--color-yellow);
  --pyly-mark-weight: 600;

  --pyly-italic-weight: 300;
}

@utility pyly-body-dt {
  @apply font-sans text-xs/normal font-medium text-muted-fg uppercase;

  --pyly-ref-thickness: 2px;
  --pyly-ref-offset: 2px;
  --pyly-ref-color: var(--color-fg-loud);
  --pyly-ref-weight: 600;

  --pyly-bold-color: var(--color-fg-loud);
  --pyly-bold-weight: 600;

  --pyly-mark-color: var(--color-yellow);
  --pyly-mark-weight: 600;
}

@utility pyly-body-input {
  @apply font-sans text-lg/snug font-medium text-fg;

  --pyly-ref-thickness: 3px;
  --pyly-ref-offset: 3px;
  --pyly-ref-color: var(--color-fg-loud);
  --pyly-ref-weight: 600;

  --pyly-bold-color: var(--color-fg-loud);
  --pyly-bold-weight: 600;

  --pyly-mark-color: var(--color-yellow);
  --pyly-mark-weight: 600;
}

@utility pyly-dev-dt {
  @apply font-mono text-xs/normal font-normal text-muted-fg uppercase;
}

@utility font-sans {
  /*
  Safari tries to work out its own "bold" weight, because it's a variable
  weight font. This disables that behaviour.
  */
  font-synthesis: none;
  /*
  Make webkit (e.g. Safari) render the font the same way as Figma
  https://forum.figma.com/ask-the-community-7/font-in-browser-seem-bolder-than-in-the-figma-8146#post54600
  */
  @apply antialiased;
}

/* --- */

@utility pyly-mark {
  text-decoration-skip-ink: none;
  color: var(
    --pyly-mark-color,
    var(--pyly-mark-color-default, var(--color-yellow))
  );
  font-weight: var(--pyly-mark-weight, var(--pyly-mark-weight-default, 600));
  text-decoration-thickness: var(--pyly-mark-thickness, from-font);
  text-underline-offset: var(--pyly-mark-offset, auto);

  @apply underline decoration-currentColor/40;

  /* Fix Safari bug where the underline text decoration isn't redrawn
    correctly because Safari doesn't correctly mark the pixels as dirty on
    hover. */

  @apply hover:transform-gpu;
}

/* --- */

@utility pyly-ref {
  text-decoration-skip-ink: none;
  color: var(
    --pyly-ref-color,
    var(--pyly-ref-color-default, var(--color-fg-loud))
  );
  font-weight: var(--pyly-ref-weight, var(--pyly-ref-weight-default, 500));
  text-decoration-thickness: var(
    --pyly-ref-thickness,
    var(--pyly-ref-thickness-default, 3px)
  );
  text-underline-offset: var(
    --pyly-ref-offset,
    var(--pyly-ref-offset-default, 2px)
  );

  @apply underline decoration-currentColor/25 hover:decoration-currentColor/50;

  /* Fix Safari bug where the underline text decoration isn't redrawn
    correctly because Safari doesn't correctly mark the pixels as dirty on
    hover. */

  @apply hover:transform-gpu;
}

@utility pyly-bold {
  color: var(
    --pyly-bold-color,
    var(--pyly-bold-color-default, var(--color-fg-loud))
  );
  font-weight: var(--pyly-bold-weight, var(--pyly-bold-weight-default, 600));
}

@utility pyly-italic {
  font-weight: var(
    --pyly-italic-weight,
    var(--pyly-italic-weight-default, 400)
  );

  @apply italic;
}

/* --- */

@utility tab-size-2 {
  tab-size: 2;
}

@layer theme {
  :root {
    @variant dark {
      --color-accent-fg: #1c9cf0;
      --color-accent: #061622;
      --color-bg-high: #2d3031;
      --color-bg: #1a1d1e;
      --color-border: #242628;
      --color-destructive-fg: oklch(0.985 0 0);
      --color-destructive: oklch(0.704 0.191 22.216);
      --color-fg-loud: #ffffff;
      --color-fg: #d7d8d9;
      --color-muted-fg: #898989;
      --color-muted: #2d3031;
    }

    @variant dark-popover {
      --color-accent-fg: #78c5f9;
      --color-accent: #39474b;
      --color-bg-high: #2d3031;
      --color-bg: #2d3031;
      --color-border: #35393a;
      --color-destructive-fg: oklch(0.985 0 0);
      --color-destructive: oklch(0.704 0.191 22.216);
      --color-fg-loud: #ffffff;
      --color-fg: #d7d8d9;
      --color-muted-fg: #898989;
      --color-muted: #2d3031;
    }

    @variant dark-danger-panel {
      --color-accent-fg: #1c9cf0;
      --color-accent: #061622;
      --color-bg-high: #413435;
      --color-bg: #2d3031;
      --color-border: #242628;
      --color-destructive-fg: oklch(0.985 0 0);
      --color-destructive: oklch(0.704 0.191 22.216);
      --color-fg-loud: #ff7377;
      --color-fg: #f2555a;
      --color-muted-fg: #db4b4f;
      --color-muted: #2d3031;
    }

    @variant dark-grass-panel {
      --color-accent-fg: #1c9cf0;
      --color-accent: #061622;
      --color-bg-high: #19c892;
      --color-bg: #00c286;
      --color-border: #242628;
      --color-destructive-fg: oklch(0.985 0 0);
      --color-destructive: oklch(0.704 0.191 22.216);
      --color-fg-loud: white;
      --color-fg: rgb(from white r g b / 0.95);
      --color-muted-fg: rgb(from white r g b / 0.57);
      --color-muted: #2d3031;
    }

    @variant dark-sky-panel {
      --color-accent-fg: #1c9cf0;
      --color-accent: #061622;
      --color-bg-high: #1f6991;
      --color-bg: var(--color-sky);
      --color-border: #242628;
      --color-destructive-fg: oklch(0.985 0 0);
      --color-destructive: oklch(0.704 0.191 22.216);
      --color-fg-loud: white;
      --color-fg: rgb(from white r g b / 0.95);
      --color-muted-fg: rgb(from white r g b / 0.57);
      --color-muted: #2d3031;
    }

    @variant dark-success-panel {
      --color-accent-fg: #1c9cf0;
      --color-accent: #061622;
      --color-bg-high: #184525;
      --color-bg: #193222;
      --color-border: #242628;
      --color-destructive-fg: oklch(0.985 0 0);
      --color-destructive: oklch(0.704 0.191 22.216);
      --color-fg-loud: #4dff73;
      --color-fg: #13f042;
      --color-muted-fg: #0b9d2b;
      --color-muted: #2d3031;
    }

    @variant dark-warning-panel {
      --color-accent-fg: #1c9cf0;
      --color-accent: #061622;
      --color-bg-high: #563307;
      --color-bg: #432004;
      --color-border: #242628;
      --color-destructive-fg: oklch(0.985 0 0);
      --color-destructive: oklch(0.704 0.191 22.216);
      --color-fg-loud: #ffe962;
      --color-fg: #ffdf20;
      --color-muted-fg: #c7ad1b;
      --color-muted: #2d3031;
    }

    @variant dark-placeholder-panel {
      --color-accent-fg: #1c9cf0;
      --color-accent: #061622;
      --color-bg-high: #2d3031;
      --color-bg: #242727;
      --color-border: #242628;
      --color-destructive-fg: oklch(0.985 0 0);
      --color-destructive: oklch(0.704 0.191 22.216);
      --color-fg-loud: #898989;
      --color-fg: #484a4b;
      --color-muted-fg: #3b3c3d;
      --color-muted: #2d3031;
    }

    @variant light {
      --color-accent-fg: #1e9df1;
      --color-accent: #e3ecf6;
      --color-bg-high: #e1e3e4;
      --color-bg: #f8f9fa;
      --color-border: #e1eaef;
      --color-destructive-fg: oklch(1 0 0);
      --color-destructive: oklch(0.577 0.245 27.325);
      --color-fg-loud: #000000;
      --color-fg: #12191d;
      --color-muted-fg: #6c6c6c;
      --color-muted: #e5e5e6;
    }

    @variant light-popover {
      --color-accent-fg: #1e9df1;
      --color-accent: #e3ecf6;
      --color-bg-high: #e1e3e4;
      --color-bg: #f8f9fa;
      --color-border: #d7e0e5;
      --color-destructive-fg: oklch(1 0 0);
      --color-destructive: oklch(0.577 0.245 27.325);
      --color-fg-loud: #000000;
      --color-fg: #12191d;
      --color-muted-fg: #6c6c6c;
      --color-muted: #e5e5e6;
    }

    @variant light-danger-panel {
      --color-accent-fg: #1e9df1;
      --color-accent: #e3ecf6;
      --color-bg-high: #e5d6d7;
      --color-bg: #e7e8e8;
      --color-border: #e1eaef;
      --color-destructive-fg: oklch(1 0 0);
      --color-destructive: oklch(0.577 0.245 27.325);
      --color-fg-loud: #d82128;
      --color-fg: #d8373d;
      --color-muted-fg: #d55f63;
      --color-muted: #e5e5e6;
    }

    @variant light-grass-panel {
      --color-accent-fg: #1e9df1;
      --color-accent: #e3ecf6;
      --color-bg-high: #18c892;
      --color-bg: #00c286;
      --color-border: #e1eaef;
      --color-destructive-fg: oklch(1 0 0);
      --color-destructive: oklch(0.577 0.245 27.325);
      --color-fg-loud: white;
      --color-fg: rgb(from white r g b / 0.95);
      --color-muted-fg: rgb(from white r g b / 0.57);
      --color-muted: #e5e5e6;
    }

    @variant light-sky-panel {
      --color-accent-fg: #1e9df1;
      --color-accent: #e3ecf6;
      --color-bg-high: #4e8ef7;
      --color-bg: var(--color-sky);
      --color-border: #e1eaef;
      --color-destructive-fg: oklch(1 0 0);
      --color-destructive: oklch(0.577 0.245 27.325);
      --color-fg-loud: white;
      --color-fg: rgb(from white r g b / 0.95);
      --color-muted-fg: rgb(from white r g b / 0.57);
      --color-muted: #e5e5e6;
    }

    @variant light-success-panel {
      --color-accent-fg: #1e9df1;
      --color-accent: #e3ecf6;
      --color-bg-high: #cef1d0;
      --color-bg: #e5f9e7;
      --color-border: #e1eaef;
      --color-destructive-fg: oklch(1 0 0);
      --color-destructive: oklch(0.577 0.245 27.325);
      --color-fg-loud: #008e00;
      --color-fg: #00ab00;
      --color-muted-fg: #48b948;
      --color-muted: #e5e5e6;
    }

    @variant light-warning-panel {
      --color-accent-fg: #1e9df1;
      --color-accent: #e3ecf6;
      --color-bg-high: #f9f0d1;
      --color-bg: #fefce8;
      --color-border: #e1eaef;
      --color-destructive-fg: oklch(1 0 0);
      --color-destructive: oklch(0.577 0.245 27.325);
      --color-fg-loud: #a65f00;
      --color-fg: #d08700;
      --color-muted-fg: #c3a625;
      --color-muted: #e5e5e6;
    }

    @variant light-placeholder-panel {
      --color-accent-fg: #1e9df1;
      --color-accent: #e3ecf6;
      --color-bg-high: #ffffff;
      --color-bg: #ecedee;
      --color-border: #e1eaef;
      --color-destructive-fg: oklch(1 0 0);
      --color-destructive: oklch(0.577 0.245 27.325);
      --color-fg-loud: #6c6c6c;
      --color-fg: #c1c3c5;
      --color-muted-fg: #828282;
      --color-muted: #e5e5e6;
    }
  }
}

@layer components {
  /*
  
  TEXT STYLES
  
  */
  .pyly-button-outline {
    @apply font-sans text-base/snug font-bold uppercase text-fg;
  }

  /* --- */
  .pyly-body,
  .pyly-mdx-h5,
  .pyly-mdx-h6,
  .pyly-mdx-p {
    @apply font-sans text-base/normal text-fg font-normal;

    --pyly-ref-thickness: 3px;
    --pyly-ref-offset: 2px;
    --pyly-ref-color: var(--color-fg-loud);
    --pyly-ref-weight: 500;

    --pyly-bold-color: var(--color-fg-loud);
    --pyly-bold-weight: 600;

    --pyly-mark-color: var(--color-fg-loud);
    --pyly-mark-weight: 600;
    --pyly-mark-thickness: 3px;
    --pyly-mark-offset: 2px;
  }

  /* --- */

  /* <pyly-body-title> */
  .pyly-body-title {
    @apply font-sans text-2xl/normal tracking-tight text-fg font-bold;
  }
  /* </pyly-body-title> */

  /* --- */

  .pyly-body-heading {
    @apply font-sans text-lg/normal tracking-tight text-fg-loud font-bold;
  }

  /* --- */

  .pyly-body-subheading {
    @apply font-sans text-sm/normal text-fg-loud font-bold uppercase;
  }

  /* --- */

  .pyly-body-dt {
    @apply font-sans text-xs/normal font-medium text-muted-fg uppercase;
  }

  /* --- */

  .pyly-dev-dt {
    @apply font-mono text-xs/normal font-normal text-muted-fg uppercase;
  }

  /* www */
  .www-text-hero {
    @apply font-sans text-5xl/tight font-bold tracking-tighter text-fg transition-all md:text-6xl/tight;
  }

  .www-text-title {
    @apply font-sans text-3xl/normal font-bold tracking-tighter text-fg transition-all md:text-4xl/normal;
  }

  .www-text-subtitle {
    @apply font-sans text-base uppercase text-cyanold;
  }

  .www-text-body {
    @apply font-sans text-fg text-[17px]/[24px];
  }

  .www-px-comfortable {
    @apply px-safe-or-4 md:px-safe-or-8;
  }

  .www-text-footer-title {
    @apply font-sans text-[19px]/normal font-medium text-fg;
  }

  .www-text-footer-link {
    @apply font-sans text-[15px]/normal font-medium text-fg antialiased;
  }

  /* 
  
  COLOR SCHEMES

  */
  .pyly-color-scheme-dark {
    --color-red: var(--color-red-dark);
    --color-orange: var(--color-orange-dark);
    --color-amber: var(--color-amber-dark);
    --color-yellow: var(--color-yellow-dark);
    --color-lime: var(--color-lime-dark);
    --color-wasabi: var(--color-wasabi-dark);
    --color-green: var(--color-green-dark);
    --color-emerald: var(--color-emerald-dark);
    --color-teal: var(--color-teal-dark);
    --color-cyan: var(--color-cyan-dark);
    --color-cyanold: var(--color-cyanold-dark);
    --color-sky: var(--color-sky-dark);
    --color-blue: var(--color-blue-dark);
    --color-indigo: var(--color-indigo-dark);
    --color-violet: var(--color-violet-dark);
    --color-purple: var(--color-purple-dark);
    --color-fuchsia: var(--color-fuchsia-dark);
    --color-pink: var(--color-pink-dark);
    --color-rose: var(--color-rose-dark);
    --color-brick: var(--color-brick-dark);
    --color-slate: var(--color-slate-dark);
    --color-gray: var(--color-gray-dark);
    --color-zinc: var(--color-zinc-dark);
    --color-neutral: var(--color-neutral-dark);
    --color-stone: var(--color-stone-dark);
    --color-cloud: var(--color-cloud-dark);

    --color-success: var(--color-wasabi);
    --color-danger: #f46368;
    --color-warning: #ffb900;

    --color-lozenge-emerald-bg: rgb(from var(--color-emerald) r g b / 0);
    --color-lozenge-emerald-fg: var(--color-emerald);
    --color-lozenge-emerald-border: rgb(from var(--color-emerald) r g b / 0.6);

    --color-lozenge-blue-bg: rgb(from var(--color-blue) r g b / 0);
    --color-lozenge-blue-fg: var(--color-blue);
    --color-lozenge-blue-border: rgb(from var(--color-blue) r g b / 0.6);

    --color-lozenge-cyan-bg: rgb(from var(--color-cyan) r g b / 0);
    --color-lozenge-cyan-fg: var(--color-cyan);
    --color-lozenge-cyan-border: rgb(from var(--color-cyan) r g b / 0.6);

    --color-lozenge-violet-bg: rgb(from var(--color-violet) r g b / 0);
    --color-lozenge-violet-fg: var(--color-violet);
    --color-lozenge-violet-border: rgb(from var(--color-violet) r g b / 0.6);
    --color-lozenge-fuchsia-bg: rgb(from var(--color-fuchsia) r g b / 0);
    --color-lozenge-fuchsia-fg: var(--color-fuchsia);
    --color-lozenge-fuchsia-border: rgb(from var(--color-fuchsia) r g b / 0.6);
    --color-lozenge-rose-bg: rgb(from var(--color-rose) r g b / 0);
    --color-lozenge-rose-fg: var(--color-rose);
    --color-lozenge-rose-border: rgb(from var(--color-rose) r g b / 0.6);
    --color-lozenge-orange-bg: rgb(from var(--color-orange) r g b / 0);
    --color-lozenge-orange-fg: var(--color-orange);
    --color-lozenge-orange-border: rgb(from var(--color-orange) r g b / 0.6);
    --color-lozenge-amber-bg: rgb(from var(--color-amber) r g b / 0);
    --color-lozenge-amber-fg: var(--color-amber);
    --color-lozenge-amber-border: rgb(from var(--color-amber) r g b / 0.6);
  }

  .pyly-color-scheme-light {
    --color-red: var(--color-red-light);
    --color-orange: var(--color-orange-light);
    --color-amber: var(--color-amber-light);
    --color-yellow: var(--color-yellow-light);
    --color-lime: var(--color-lime-light);
    --color-wasabi: var(--color-wasabi-light);
    --color-green: var(--color-green-light);
    --color-emerald: var(--color-emerald-light);
    --color-teal: var(--color-teal-light);
    --color-cyan: var(--color-cyan-light);
    --color-cyanold: var(--color-cyanold-light);
    --color-sky: var(--color-sky-light);
    --color-blue: var(--color-blue-light);
    --color-indigo: var(--color-indigo-light);
    --color-violet: var(--color-violet-light);
    --color-purple: var(--color-purple-light);
    --color-fuchsia: var(--color-fuchsia-light);
    --color-pink: var(--color-pink-light);
    --color-rose: var(--color-rose-light);
    --color-brick: var(--color-brick-light);
    --color-slate: var(--color-slate-light);
    --color-gray: var(--color-gray-light);
    --color-zinc: var(--color-zinc-light);
    --color-neutral: var(--color-neutral-light);
    --color-stone: var(--color-stone-light);
    --color-cloud: var(--color-cloud-light);

    --color-success: var(--color-wasabi);
    --color-danger: #d8373d;
    --color-warning: #ff8904;

    --color-lozenge-emerald-bg: rgb(from var(--color-emerald) r g b / 0.05);
    --color-lozenge-emerald-fg: var(--color-emerald);
    --color-lozenge-emerald-border: rgb(from var(--color-emerald) r g b / 0.5);

    --color-lozenge-blue-bg: rgb(from var(--color-blue) r g b / 0.05);
    --color-lozenge-blue-fg: var(--color-blue);
    --color-lozenge-blue-border: rgb(from var(--color-blue) r g b / 0.5);

    --color-lozenge-cyan-bg: rgb(from var(--color-cyan) r g b / 0.05);
    --color-lozenge-cyan-fg: var(--color-cyan);
    --color-lozenge-cyan-border: rgb(from var(--color-cyan) r g b / 0.5);

    --color-lozenge-violet-bg: rgb(from var(--color-violet) r g b / 0.05);
    --color-lozenge-violet-fg: var(--color-violet);
    --color-lozenge-violet-border: rgb(from var(--color-violet) r g b / 0.5);

    --color-lozenge-fuchsia-bg: rgb(from var(--color-fuchsia) r g b / 0.05);
    --color-lozenge-fuchsia-fg: var(--color-fuchsia);
    --color-lozenge-fuchsia-border: rgb(from var(--color-fuchsia) r g b / 0.5);

    --color-lozenge-rose-bg: rgb(from var(--color-rose) r g b / 0.05);
    --color-lozenge-rose-fg: var(--color-rose);
    --color-lozenge-rose-border: rgb(from var(--color-rose) r g b / 0.5);

    --color-lozenge-orange-bg: rgb(from var(--color-orange) r g b / 0.05);
    --color-lozenge-orange-fg: var(--color-orange);
    --color-lozenge-orange-border: rgb(from var(--color-orange) r g b / 0.5);

    --color-lozenge-amber-bg: rgb(from var(--color-amber) r g b / 0.05);
    --color-lozenge-amber-fg: var(--color-amber);
    --color-lozenge-amber-border: rgb(from var(--color-amber) r g b / 0.5);
  }

  /* declare MDX component clases */
  .pyly-mdx,
  .pyly-mdx-b,
  .pyly-mdx-strong,
  .pyly-mdx-s,
  .pyly-mdx-del,
  .pyly-mdx-q,
  .pyly-mdx-i,
  .pyly-mdx-em,
  .pyly-mdx-p,
  .pyly-mdx-pre,
  .pyly-mdx-code,
  .pyly-mdx-inlineCode,
  .pyly-mdx-span,
  .pyly-mdx-a,
  .pyly-mdx-nav,
  .pyly-mdx-footer,
  .pyly-mdx-aside,
  .pyly-mdx-header,
  .pyly-mdx-main,
  .pyly-mdx-article,
  .pyly-mdx-section,
  .pyly-mdx-br,
  .pyly-mdx-time,
  .pyly-mdx-div,
  .pyly-mdx-img,
  .pyly-mdx-tbody,
  .pyly-mdx-blockquote {
    --pyly-ignore-lint-warning: 1;
  }

  .pyly-mdx-mark {
    @apply text-yellow font-bold;
  }

  .pyly-mdx-h1 {
    @apply pyly-body-title;
  }
  .pyly-mdx-h2,
  .pyly-mdx-h3,
  .pyly-mdx-h4 {
    @apply pyly-body-heading;
  }
  .pyly-mdx-h5,
  .pyly-mdx-h6 {
    @apply font-bold;
  }
  .pyly-mdx-b,
  .pyly-mdx-strong {
    @apply font-semibold text-fg-loud;
  }

  .pyly-mdx-p {
    /* Override react-native-web's default `white-space: pre-wrap` so that
    newlines in MDX are not treated as line breaks. In MDX if you want a line
    break you can use two trailing spaces at the end of a line and it is a
    `<BR>`. */

    @apply whitespace-normal;
  }
  .pyly-mdx-blockquote {
    @apply border-l-4 border-l-fg/50 pl-4 py-2;
  }

  .pyly-mdx-hr {
    @apply border-t-[0.5px] border-fg/25 border-dashed my-4 flex-1;
  }

  .pyly-mdx-table {
    @apply my-4 overflow-hidden rounded-lg border border-fg/20;
  }
  .pyly-mdx-thead {
    @apply bg-fg/5;
  }
  .pyly-mdx-tr {
    @apply flex-row border-b border-fg/10 last:border-b-0;
  }

  .pyly-mdx > ul,
  .pyly-mdx > ol {
    @apply pl-6;
  }
  .pyly-mdx > ul > li > ul {
    @apply my-2;
  }

  .pyly-token {
    @apply my-0 rounded-sm bg-gradient-to-b from-sky-400/50 via-sky-500/50 to-sky-500/50 px-1 leading-5.5 font-medium text-white shadow-sm outline -outline-offset-1 outline-sky-400;
  }
}

body {
  @apply bg-bg;
}

:root {
  --color-cloud-light: #cdcdcd;
  --color-cloud-dark: #d9d9d9;
  --color-brick-light: #dc3e43;
  --color-brick-dark: #f2555a;
  --color-red-light: #e7000b;
  --color-red-dark: #e7000b;
  --color-orange-light: #f54900;
  --color-orange-dark: #ff8904;
  --color-amber-light: #e17100;
  --color-amber-dark: #ffb900;
  --color-yellow-light: #fcbc14;
  --color-yellow-dark: #fcbc14;
  --color-lime-light: #5ea500;
  --color-lime-dark: #9ae600;
  --color-wasabi-light: #00c410;
  --color-wasabi-dark: #13f042;
  --color-green-light: #008236;
  --color-green-dark: #05df72;
  --color-emerald-light: #007a55;
  --color-emerald-dark: #00d492;
  --color-teal-light: #00786f;
  --color-teal-dark: #00d5be;
  --color-cyan-light: #007595;
  --color-cyan-dark: #00d3f2;
  --color-cyanold-light: #00bae9;
  --color-cyanold-dark: #00d3f2;
  --color-sky-light: #3b82f6;
  --color-sky-dark: #075985;
  --color-blue-light: #1447e6;
  --color-blue-dark: #2b7fff;
  --color-indigo-light: #4f39f6;
  --color-indigo-dark: #615fff;
  --color-violet-light: #7f22fe;
  --color-violet-dark: #8e51ff;
  --color-purple-light: #9810fa;
  --color-purple-dark: #ad46ff;
  --color-fuchsia-light: #c800de;
  --color-fuchsia-dark: #e12afb;
  --color-pink-light: #e60076;
  --color-pink-dark: #f6339a;
  --color-rose-light: #ec003f;
  --color-rose-dark: #ff2056;
  --color-slate-light: #45556c;
  --color-slate-dark: #90a1b9;
  --color-gray-light: #4a5565;
  --color-gray-dark: #99a1af;
  --color-zinc-light: #52525c;
  --color-zinc-dark: #9f9fa9;
  --color-neutral-light: #525252;
  --color-neutral-dark: #a1a1a1;
  --color-stone-light: #57534d;
  --color-stone-dark: #a6a09b;

  /* <tailwind-colors> */
  --color-tw-red-50: oklch(0.971 0.013 17.38);
  --color-tw-red-100: oklch(0.936 0.032 17.717);
  --color-tw-red-200: oklch(0.885 0.062 18.334);
  --color-tw-red-300: oklch(0.808 0.114 19.571);
  --color-tw-red-400: oklch(0.704 0.191 22.216);
  --color-tw-red-500: oklch(0.637 0.237 25.331);
  --color-tw-red-600: oklch(0.577 0.245 27.325);
  --color-tw-red-700: oklch(0.505 0.213 27.518);
  --color-tw-red-800: oklch(0.444 0.177 26.899);
  --color-tw-red-900: oklch(0.396 0.141 25.723);
  --color-tw-red-950: oklch(0.258 0.092 26.042);
  --color-tw-orange-50: oklch(0.98 0.016 73.684);
  --color-tw-orange-100: oklch(0.954 0.038 75.164);
  --color-tw-orange-200: oklch(0.901 0.076 70.697);
  --color-tw-orange-300: oklch(0.837 0.128 66.29);
  --color-tw-orange-400: oklch(0.75 0.183 55.934);
  --color-tw-orange-500: oklch(0.705 0.213 47.604);
  --color-tw-orange-600: oklch(0.646 0.222 41.116);
  --color-tw-orange-700: oklch(0.553 0.195 38.402);
  --color-tw-orange-800: oklch(0.47 0.157 37.304);
  --color-tw-orange-900: oklch(0.408 0.123 38.172);
  --color-tw-orange-950: oklch(0.266 0.079 36.259);
  --color-tw-amber-50: oklch(0.987 0.022 95.277);
  --color-tw-amber-100: oklch(0.962 0.059 95.617);
  --color-tw-amber-200: oklch(0.924 0.12 95.746);
  --color-tw-amber-300: oklch(0.879 0.169 91.605);
  --color-tw-amber-400: oklch(0.828 0.189 84.429);
  --color-tw-amber-500: oklch(0.769 0.188 70.08);
  --color-tw-amber-600: oklch(0.666 0.179 58.318);
  --color-tw-amber-700: oklch(0.555 0.163 48.998);
  --color-tw-amber-800: oklch(0.473 0.137 46.201);
  --color-tw-amber-900: oklch(0.414 0.112 45.904);
  --color-tw-amber-950: oklch(0.279 0.077 45.635);
  --color-tw-yellow-50: oklch(0.987 0.026 102.212);
  --color-tw-yellow-100: oklch(0.973 0.071 103.193);
  --color-tw-yellow-200: oklch(0.945 0.129 101.54);
  --color-tw-yellow-300: oklch(0.905 0.182 98.111);
  --color-tw-yellow-400: oklch(0.852 0.199 91.936);
  --color-tw-yellow-500: oklch(0.795 0.184 86.047);
  --color-tw-yellow-600: oklch(0.681 0.162 75.834);
  --color-tw-yellow-700: oklch(0.554 0.135 66.442);
  --color-tw-yellow-800: oklch(0.476 0.114 61.907);
  --color-tw-yellow-900: oklch(0.421 0.095 57.708);
  --color-tw-yellow-950: oklch(0.286 0.066 53.813);
  --color-tw-lime-50: oklch(0.986 0.031 120.757);
  --color-tw-lime-100: oklch(0.967 0.067 122.328);
  --color-tw-lime-200: oklch(0.938 0.127 124.321);
  --color-tw-lime-300: oklch(0.897 0.196 126.665);
  --color-tw-lime-400: oklch(0.841 0.238 128.85);
  --color-tw-lime-500: oklch(0.768 0.233 130.85);
  --color-tw-lime-600: oklch(0.648 0.2 131.684);
  --color-tw-lime-700: oklch(0.532 0.157 131.589);
  --color-tw-lime-800: oklch(0.453 0.124 130.933);
  --color-tw-lime-900: oklch(0.405 0.101 131.063);
  --color-tw-lime-950: oklch(0.274 0.072 132.109);
  --color-tw-green-50: oklch(0.982 0.018 155.826);
  --color-tw-green-100: oklch(0.962 0.044 156.743);
  --color-tw-green-200: oklch(0.925 0.084 155.995);
  --color-tw-green-300: oklch(0.871 0.15 154.449);
  --color-tw-green-400: oklch(0.792 0.209 151.711);
  --color-tw-green-500: oklch(0.723 0.219 149.579);
  --color-tw-green-600: oklch(0.627 0.194 149.214);
  --color-tw-green-700: oklch(0.527 0.154 150.069);
  --color-tw-green-800: oklch(0.448 0.119 151.328);
  --color-tw-green-900: oklch(0.393 0.095 152.535);
  --color-tw-green-950: oklch(0.266 0.065 152.934);
  --color-tw-emerald-50: oklch(0.979 0.021 166.113);
  --color-tw-emerald-100: oklch(0.95 0.052 163.051);
  --color-tw-emerald-200: oklch(0.905 0.093 164.15);
  --color-tw-emerald-300: oklch(0.845 0.143 164.978);
  --color-tw-emerald-400: oklch(0.765 0.177 163.223);
  --color-tw-emerald-500: oklch(0.696 0.17 162.48);
  --color-tw-emerald-600: oklch(0.596 0.145 163.225);
  --color-tw-emerald-700: oklch(0.508 0.118 165.612);
  --color-tw-emerald-800: oklch(0.432 0.095 166.913);
  --color-tw-emerald-900: oklch(0.378 0.077 168.94);
  --color-tw-emerald-950: oklch(0.262 0.051 172.552);
  --color-tw-teal-50: oklch(0.984 0.014 180.72);
  --color-tw-teal-100: oklch(0.953 0.051 180.801);
  --color-tw-teal-200: oklch(0.91 0.096 180.426);
  --color-tw-teal-300: oklch(0.855 0.138 181.071);
  --color-tw-teal-400: oklch(0.777 0.152 181.912);
  --color-tw-teal-500: oklch(0.704 0.14 182.503);
  --color-tw-teal-600: oklch(0.6 0.118 184.704);
  --color-tw-teal-700: oklch(0.511 0.096 186.391);
  --color-tw-teal-800: oklch(0.437 0.078 188.216);
  --color-tw-teal-900: oklch(0.386 0.063 188.416);
  --color-tw-teal-950: oklch(0.277 0.046 192.524);
  --color-tw-cyan-50: oklch(0.984 0.019 200.873);
  --color-tw-cyan-100: oklch(0.956 0.045 203.388);
  --color-tw-cyan-200: oklch(0.917 0.08 205.041);
  --color-tw-cyan-300: oklch(0.865 0.127 207.078);
  --color-tw-cyan-400: oklch(0.789 0.154 211.53);
  --color-tw-cyan-500: oklch(0.715 0.143 215.221);
  --color-tw-cyan-600: oklch(0.609 0.126 221.723);
  --color-tw-cyan-700: oklch(0.52 0.105 223.128);
  --color-tw-cyan-800: oklch(0.45 0.085 224.283);
  --color-tw-cyan-900: oklch(0.398 0.07 227.392);
  --color-tw-cyan-950: oklch(0.302 0.056 229.695);
  --color-tw-sky-50: oklch(0.977 0.013 236.62);
  --color-tw-sky-100: oklch(0.951 0.026 236.824);
  --color-tw-sky-200: oklch(0.901 0.058 230.902);
  --color-tw-sky-300: oklch(0.828 0.111 230.318);
  --color-tw-sky-400: oklch(0.746 0.16 232.661);
  --color-tw-sky-500: oklch(0.685 0.169 237.323);
  --color-tw-sky-600: oklch(0.588 0.158 241.966);
  --color-tw-sky-700: oklch(0.5 0.134 242.749);
  --color-tw-sky-800: oklch(0.443 0.11 240.79);
  --color-tw-sky-900: oklch(0.391 0.09 240.876);
  --color-tw-sky-950: oklch(0.293 0.066 243.157);
  --color-tw-blue-50: oklch(0.97 0.014 254.604);
  --color-tw-blue-100: oklch(0.932 0.032 255.585);
  --color-tw-blue-200: oklch(0.882 0.059 254.128);
  --color-tw-blue-300: oklch(0.809 0.105 251.813);
  --color-tw-blue-400: oklch(0.707 0.165 254.624);
  --color-tw-blue-500: oklch(0.623 0.214 259.815);
  --color-tw-blue-600: oklch(0.546 0.245 262.881);
  --color-tw-blue-700: oklch(0.488 0.243 264.376);
  --color-tw-blue-800: oklch(0.424 0.199 265.638);
  --color-tw-blue-900: oklch(0.379 0.146 265.522);
  --color-tw-blue-950: oklch(0.282 0.091 267.935);
  --color-tw-indigo-50: oklch(0.962 0.018 272.314);
  --color-tw-indigo-100: oklch(0.93 0.034 272.788);
  --color-tw-indigo-200: oklch(0.87 0.065 274.039);
  --color-tw-indigo-300: oklch(0.785 0.115 274.713);
  --color-tw-indigo-400: oklch(0.673 0.182 276.935);
  --color-tw-indigo-500: oklch(0.585 0.233 277.117);
  --color-tw-indigo-600: oklch(0.511 0.262 276.966);
  --color-tw-indigo-700: oklch(0.457 0.24 277.023);
  --color-tw-indigo-800: oklch(0.398 0.195 277.366);
  --color-tw-indigo-900: oklch(0.359 0.144 278.697);
  --color-tw-indigo-950: oklch(0.257 0.09 281.288);
  --color-tw-violet-50: oklch(0.969 0.016 293.756);
  --color-tw-violet-100: oklch(0.943 0.029 294.588);
  --color-tw-violet-200: oklch(0.894 0.057 293.283);
  --color-tw-violet-300: oklch(0.811 0.111 293.571);
  --color-tw-violet-400: oklch(0.702 0.183 293.541);
  --color-tw-violet-500: oklch(0.606 0.25 292.717);
  --color-tw-violet-600: oklch(0.541 0.281 293.009);
  --color-tw-violet-700: oklch(0.491 0.27 292.581);
  --color-tw-violet-800: oklch(0.432 0.232 292.759);
  --color-tw-violet-900: oklch(0.38 0.189 293.745);
  --color-tw-violet-950: oklch(0.283 0.141 291.089);
  --color-tw-purple-50: oklch(0.977 0.014 308.299);
  --color-tw-purple-100: oklch(0.946 0.033 307.174);
  --color-tw-purple-200: oklch(0.902 0.063 306.703);
  --color-tw-purple-300: oklch(0.827 0.119 306.383);
  --color-tw-purple-400: oklch(0.714 0.203 305.504);
  --color-tw-purple-500: oklch(0.627 0.265 303.9);
  --color-tw-purple-600: oklch(0.558 0.288 302.321);
  --color-tw-purple-700: oklch(0.496 0.265 301.924);
  --color-tw-purple-800: oklch(0.438 0.218 303.724);
  --color-tw-purple-900: oklch(0.381 0.176 304.987);
  --color-tw-purple-950: oklch(0.291 0.149 302.717);
  --color-tw-fuchsia-50: oklch(0.977 0.017 320.058);
  --color-tw-fuchsia-100: oklch(0.952 0.037 318.852);
  --color-tw-fuchsia-200: oklch(0.903 0.076 319.62);
  --color-tw-fuchsia-300: oklch(0.833 0.145 321.434);
  --color-tw-fuchsia-400: oklch(0.74 0.238 322.16);
  --color-tw-fuchsia-500: oklch(0.667 0.295 322.15);
  --color-tw-fuchsia-600: oklch(0.591 0.293 322.896);
  --color-tw-fuchsia-700: oklch(0.518 0.253 323.949);
  --color-tw-fuchsia-800: oklch(0.452 0.211 324.591);
  --color-tw-fuchsia-900: oklch(0.401 0.17 325.612);
  --color-tw-fuchsia-950: oklch(0.293 0.136 325.661);
  --color-tw-pink-50: oklch(0.971 0.014 343.198);
  --color-tw-pink-100: oklch(0.948 0.028 342.258);
  --color-tw-pink-200: oklch(0.899 0.061 343.231);
  --color-tw-pink-300: oklch(0.823 0.12 346.018);
  --color-tw-pink-400: oklch(0.718 0.202 349.761);
  --color-tw-pink-500: oklch(0.656 0.241 354.308);
  --color-tw-pink-600: oklch(0.592 0.249 0.584);
  --color-tw-pink-700: oklch(0.525 0.223 3.958);
  --color-tw-pink-800: oklch(0.459 0.187 3.815);
  --color-tw-pink-900: oklch(0.408 0.153 2.432);
  --color-tw-pink-950: oklch(0.284 0.109 3.907);
  --color-tw-rose-50: oklch(0.969 0.015 12.422);
  --color-tw-rose-100: oklch(0.941 0.03 12.58);
  --color-tw-rose-200: oklch(0.892 0.058 10.001);
  --color-tw-rose-300: oklch(0.81 0.117 11.638);
  --color-tw-rose-400: oklch(0.712 0.194 13.428);
  --color-tw-rose-500: oklch(0.645 0.246 16.439);
  --color-tw-rose-600: oklch(0.586 0.253 17.585);
  --color-tw-rose-700: oklch(0.514 0.222 16.935);
  --color-tw-rose-800: oklch(0.455 0.188 13.697);
  --color-tw-rose-900: oklch(0.41 0.159 10.272);
  --color-tw-rose-950: oklch(0.271 0.105 12.094);
  --color-tw-slate-50: oklch(0.984 0.003 247.858);
  --color-tw-slate-100: oklch(0.968 0.007 247.896);
  --color-tw-slate-200: oklch(0.929 0.013 255.508);
  --color-tw-slate-300: oklch(0.869 0.022 252.894);
  --color-tw-slate-400: oklch(0.704 0.04 256.788);
  --color-tw-slate-500: oklch(0.554 0.046 257.417);
  --color-tw-slate-600: oklch(0.446 0.043 257.281);
  --color-tw-slate-700: oklch(0.372 0.044 257.287);
  --color-tw-slate-800: oklch(0.279 0.041 260.031);
  --color-tw-slate-900: oklch(0.208 0.042 265.755);
  --color-tw-slate-950: oklch(0.129 0.042 264.695);
  --color-tw-gray-50: oklch(0.985 0.002 247.839);
  --color-tw-gray-100: oklch(0.967 0.003 264.542);
  --color-tw-gray-200: oklch(0.928 0.006 264.531);
  --color-tw-gray-300: oklch(0.872 0.01 258.338);
  --color-tw-gray-400: oklch(0.707 0.022 261.325);
  --color-tw-gray-500: oklch(0.551 0.027 264.364);
  --color-tw-gray-600: oklch(0.446 0.03 256.802);
  --color-tw-gray-700: oklch(0.373 0.034 259.733);
  --color-tw-gray-800: oklch(0.278 0.033 256.848);
  --color-tw-gray-900: oklch(0.21 0.034 264.665);
  --color-tw-gray-950: oklch(0.13 0.028 261.692);
  --color-tw-zinc-50: oklch(0.985 0 0);
  --color-tw-zinc-100: oklch(0.967 0.001 286.375);
  --color-tw-zinc-200: oklch(0.92 0.004 286.32);
  --color-tw-zinc-300: oklch(0.871 0.006 286.286);
  --color-tw-zinc-400: oklch(0.705 0.015 286.067);
  --color-tw-zinc-500: oklch(0.552 0.016 285.938);
  --color-tw-zinc-600: oklch(0.442 0.017 285.786);
  --color-tw-zinc-700: oklch(0.37 0.013 285.805);
  --color-tw-zinc-800: oklch(0.274 0.006 286.033);
  --color-tw-zinc-900: oklch(0.21 0.006 285.885);
  --color-tw-zinc-950: oklch(0.141 0.005 285.823);
  --color-tw-neutral-50: oklch(0.985 0 0);
  --color-tw-neutral-100: oklch(0.97 0 0);
  --color-tw-neutral-200: oklch(0.922 0 0);
  --color-tw-neutral-300: oklch(0.87 0 0);
  --color-tw-neutral-400: oklch(0.708 0 0);
  --color-tw-neutral-500: oklch(0.556 0 0);
  --color-tw-neutral-600: oklch(0.439 0 0);
  --color-tw-neutral-700: oklch(0.371 0 0);
  --color-tw-neutral-800: oklch(0.269 0 0);
  --color-tw-neutral-900: oklch(0.205 0 0);
  --color-tw-neutral-950: oklch(0.145 0 0);
  --color-tw-stone-50: oklch(0.985 0.001 106.423);
  --color-tw-stone-100: oklch(0.97 0.001 106.424);
  --color-tw-stone-200: oklch(0.923 0.003 48.717);
  --color-tw-stone-300: oklch(0.869 0.005 56.366);
  --color-tw-stone-400: oklch(0.709 0.01 56.259);
  --color-tw-stone-500: oklch(0.553 0.013 58.071);
  --color-tw-stone-600: oklch(0.444 0.011 73.639);
  --color-tw-stone-700: oklch(0.374 0.01 67.558);
  --color-tw-stone-800: oklch(0.268 0.007 34.298);
  --color-tw-stone-900: oklch(0.216 0.006 56.043);
  --color-tw-stone-950: oklch(0.147 0.004 49.25);
  --color-tw-black: #000;
  --color-tw-white: #fff;
  /* </tailwind-colors> */

  --color-red: var(--color-red-light);
  --color-orange: var(--color-orange-light);
  --color-amber: var(--color-amber-light);
  --color-yellow: var(--color-yellow-light);
  --color-lime: var(--color-lime-light);
  --color-wasabi: var(--color-wasabi-light);
  --color-green: var(--color-green-light);
  --color-emerald: var(--color-emerald-light);
  --color-teal: var(--color-teal-light);
  --color-cyan: var(--color-cyan-light);
  --color-cyanold: var(--color-cyanold-light);
  --color-sky: var(--color-sky-light);
  --color-blue: var(--color-blue-light);
  --color-indigo: var(--color-indigo-light);
  --color-violet: var(--color-violet-light);
  --color-purple: var(--color-purple-light);
  --color-fuchsia: var(--color-fuchsia-light);
  --color-pink: var(--color-pink-light);
  --color-rose: var(--color-rose-light);
  --color-brick: var(--color-brick-light);
  --color-slate: var(--color-slate-light);
  --color-gray: var(--color-gray-light);
  --color-zinc: var(--color-zinc-light);
  --color-neutral: var(--color-neutral-light);
  --color-stone: var(--color-stone-light);
  --color-cloud: var(--color-cloud-light);

  --color-success: var(--color-wasabi);
  --color-danger: #d8373d;
  --color-warning: #ff8904;

  --color-lozenge-emerald-bg: rgb(from var(--color-emerald) r g b / 0.05);
  --color-lozenge-emerald-fg: var(--color-emerald);
  --color-lozenge-emerald-border: rgb(from var(--color-emerald) r g b / 0.5);
  --color-lozenge-blue-bg: rgb(from var(--color-blue) r g b / 0.05);
  --color-lozenge-blue-fg: var(--color-blue);
  --color-lozenge-blue-border: rgb(from var(--color-blue) r g b / 0.5);
  --color-lozenge-cyan-bg: rgb(from var(--color-cyan) r g b / 0.05);
  --color-lozenge-cyan-fg: var(--color-cyan);
  --color-lozenge-cyan-border: rgb(from var(--color-cyan) r g b / 0.5);
  --color-lozenge-violet-bg: rgb(from var(--color-violet) r g b / 0.05);
  --color-lozenge-violet-fg: var(--color-violet);
  --color-lozenge-violet-border: rgb(from var(--color-violet) r g b / 0.5);
  --color-lozenge-fuchsia-bg: rgb(from var(--color-fuchsia) r g b / 0.05);
  --color-lozenge-fuchsia-fg: var(--color-fuchsia);
  --color-lozenge-fuchsia-border: rgb(from var(--color-fuchsia) r g b / 0.5);
  --color-lozenge-rose-bg: rgb(from var(--color-rose) r g b / 0.05);
  --color-lozenge-rose-fg: var(--color-rose);
  --color-lozenge-rose-border: rgb(from var(--color-rose) r g b / 0.5);
  --color-lozenge-orange-bg: rgb(from var(--color-orange) r g b / 0.05);
  --color-lozenge-orange-fg: var(--color-orange);
  --color-lozenge-orange-border: rgb(from var(--color-orange) r g b / 0.5);
  --color-lozenge-amber-bg: rgb(from var(--color-amber) r g b / 0.05);
  --color-lozenge-amber-fg: var(--color-amber);
  --color-lozenge-amber-border: rgb(from var(--color-amber) r g b / 0.5);

  --color-bg: var(--color-theme-default-bg);
  --color-bg-high: var(--color-theme-default-bg-high);
  --color-fg: var(--color-theme-default-fg);
  --color-muted-fg: var(--color-theme-default-muted-fg);
  --color-fg-loud: var(--color-theme-default-fg-loud);
}

@media (prefers-color-scheme: dark) {
  :root {
    --color-red: var(--color-red-dark);
    --color-orange: var(--color-orange-dark);
    --color-amber: var(--color-amber-dark);
    --color-yellow: var(--color-yellow-dark);
    --color-lime: var(--color-lime-dark);
    --color-wasabi: var(--color-wasabi-dark);
    --color-green: var(--color-green-dark);
    --color-emerald: var(--color-emerald-dark);
    --color-teal: var(--color-teal-dark);
    --color-cyan: var(--color-cyan-dark);
    --color-cyanold: var(--color-cyanold-dark);
    --color-sky: var(--color-sky-dark);
    --color-blue: var(--color-blue-dark);
    --color-indigo: var(--color-indigo-dark);
    --color-violet: var(--color-violet-dark);
    --color-purple: var(--color-purple-dark);
    --color-fuchsia: var(--color-fuchsia-dark);
    --color-pink: var(--color-pink-dark);
    --color-rose: var(--color-rose-dark);
    --color-brick: var(--color-brick-dark);
    --color-slate: var(--color-slate-dark);
    --color-gray: var(--color-gray-dark);
    --color-zinc: var(--color-zinc-dark);
    --color-neutral: var(--color-neutral-dark);
    --color-stone: var(--color-stone-dark);
    --color-cloud: var(--color-cloud-dark);

    --color-success: var(--color-wasabi);
    --color-danger: #f46368;
    --color-warning: #ffb900;

    --color-theme-default-bg: #1a1d1e;
    --color-theme-default-bg-high: #2d3031;
    --color-theme-default-fg: #d7d8d9;
    --color-theme-default-muted-fg: #898989;
    --color-theme-default-fg-loud: #ffffff;

    --color-theme-danger-panel-bg: #2d3031;
    --color-theme-danger-panel-bg-high: #413435;
    --color-theme-danger-panel-fg: #f2555a;
    --color-theme-danger-panel-muted-fg: #db4b4f;
    --color-theme-danger-panel-fg-loud: #ff7377;

    --color-theme-grass-panel-bg: #00c286;
    --color-theme-grass-panel-bg-high: #19c892;
    --color-theme-grass-panel-fg: rgb(from white r g b / 0.95);
    --color-theme-grass-panel-muted-fg: rgb(from white r g b / 0.57);
    --color-theme-grass-panel-fg-loud: white;

    --color-theme-sky-panel-bg: var(--color-sky);
    --color-theme-sky-panel-bg-high: #1f6991;
    --color-theme-sky-panel-fg: rgb(from white r g b / 0.95);
    --color-theme-sky-panel-muted-fg: rgb(from white r g b / 0.57);
    --color-theme-sky-panel-fg-loud: white;

    --color-theme-success-panel-bg: #193222;
    --color-theme-success-panel-bg-high: #184525;
    --color-theme-success-panel-fg: #13f042;
    --color-theme-success-panel-muted-fg: #0b9d2b;
    --color-theme-success-panel-fg-loud: #4dff73;

    --color-theme-warning-panel-bg: #432004;
    --color-theme-warning-panel-bg-high: #563307;
    --color-theme-warning-panel-fg: #ffdf20;
    --color-theme-warning-panel-muted-fg: #c7ad1b;
    --color-theme-warning-panel-fg-loud: #ffe962;

    --color-theme-placeholder-panel-bg: #242727;
    --color-theme-placeholder-panel-bg-high: #2d3031;
    --color-theme-placeholder-panel-fg: #484a4b;
    --color-theme-placeholder-panel-muted-fg: #3b3c3d;
    --color-theme-placeholder-panel-fg-loud: #898989;

    --color-lozenge-emerald-bg: rgb(from var(--color-emerald) r g b / 0);
    --color-lozenge-emerald-fg: var(--color-emerald);
    --color-lozenge-emerald-border: rgb(from var(--color-emerald) r g b / 0.6);
    --color-lozenge-blue-bg: rgb(from var(--color-blue) r g b / 0);
    --color-lozenge-blue-fg: var(--color-blue);
    --color-lozenge-blue-border: rgb(from var(--color-blue) r g b / 0.6);
    --color-lozenge-cyan-bg: rgb(from var(--color-cyan) r g b / 0);
    --color-lozenge-cyan-fg: var(--color-cyan);
    --color-lozenge-cyan-border: rgb(from var(--color-cyan) r g b / 0.6);
    --color-lozenge-violet-bg: rgb(from var(--color-violet) r g b / 0);
    --color-lozenge-violet-fg: var(--color-violet);
    --color-lozenge-violet-border: rgb(from var(--color-violet) r g b / 0.6);
    --color-lozenge-fuchsia-bg: rgb(from var(--color-fuchsia) r g b / 0);
    --color-lozenge-fuchsia-fg: var(--color-fuchsia);
    --color-lozenge-fuchsia-border: rgb(from var(--color-fuchsia) r g b / 0.6);
    --color-lozenge-rose-bg: rgb(from var(--color-rose) r g b / 0);
    --color-lozenge-rose-fg: var(--color-rose);
    --color-lozenge-rose-border: rgb(from var(--color-rose) r g b / 0.6);
    --color-lozenge-orange-bg: rgb(from var(--color-orange) r g b / 0);
    --color-lozenge-orange-fg: var(--color-orange);
    --color-lozenge-orange-border: rgb(from var(--color-orange) r g b / 0.6);
    --color-lozenge-amber-bg: rgb(from var(--color-amber) r g b / 0);
    --color-lozenge-amber-fg: var(--color-amber);
    --color-lozenge-amber-border: rgb(from var(--color-amber) r g b / 0.6);
  }
}

[data-pyly-react-navigation-screen][data-pyly-react-navigation-modal] {
  @apply absolute inset-0 fixed;
}
